import { render, staticRenderFns } from "./Riders.vue?vue&type=template&id=c0eee880"
import script from "./Riders.vue?vue&type=script&lang=js"
export * from "./Riders.vue?vue&type=script&lang=js"
import style0 from "./Riders.vue?vue&type=style&index=0&id=c0eee880&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports